module.exports = __webpack_public_path__ + "svg/file_excel.2495c46a300abf1f97358e50717837b3.svg";